import Rails from "@rails/ujs";          // ⚡ enable Rails UJS for data-method etc.
Rails.start();

import "./shims/jquery-global"; 
import "select2/dist/js/select2.full.js";
import "jquery-ui";
require('select2')();

// import * as bootstrap from "bootstrap";
import "./lib/jquery.externalscript";
import "./lib/jquery.browser";
// import "./lib/fast_fonts";
import "./lib/jquery.home";
import "./lib/open_tableau";
import "./lib/highlight_popup";

import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

import { Application } from "@hotwired/stimulus"
import BlogFormController from "./controllers/blog_form_controller"

const application = Application.start()
application.register("blog-form", BlogFormController)


// ✅ Move TinyMCE init into external module
import { initTinyMCE } from "./lib/init_tinymce"
initTinyMCE()